<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "DEVICESETUP" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
    </div>
  </div>

  <div #stepsBody class="row g-0 m-0 body mt-3 mb-3">
    @if (isInitializing) {
    <div class="initialization-container">
      <div class="initialization-text">
        {{ "RECONFIGURATION_STARTED" | translate }}
      </div>
      <div class="loading-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>
    }

    @if (!isInitializing && steps.length > 0) {
    <div class="steps-container p-3">
      <ol class="steps-list">
        @for (item of stepDisplayItems; track $index) {
        @if (item.type === 'group') {
        <li class="step-group">
          <div class="step-group-name">{{ item.groupName }}</div>
          <ul class="step-group-list">
            @for (step of item.steps; track $index) {
            <li class="step-item" [ngClass]="getStepStatusClass(step.status)">
              <span class="step-marker"></span>
              <div class="step-content">
                <div class="step-header">
                  <span class="step-name">{{ step.stepName }}</span>
                  <span class="step-status">{{ getStepStatusSuffix(step.status) }}</span>
                </div>
                @if (step.errorMessage) {
                <div class="step-error">{{ step.errorMessage }}</div>
                }
              </div>
            </li>
            }
          </ul>
        </li>
        } @else {
        <li class="step-item" [ngClass]="getStepStatusClass(item.step.status)">
          <div class="step-header">
            <span class="step-name">{{ item.step.stepName }}</span>
            <span class="step-status">{{ getStepStatusSuffix(item.step.status) }}</span>
          </div>
          @if (item.step.errorMessage) {
          <div class="step-error">{{ item.step.errorMessage }}</div>
          }
        </li>
        }
        }
        @if (stepDisplayItems.length === 0) {
        @for (step of steps; track $index) {
        <li class="step-item" [ngClass]="getStepStatusClass(step.status)">
          <div class="step-header">
            <span class="step-name">{{ step.stepName }}</span>
            <span class="step-status">{{ getStepStatusSuffix(step.status) }}</span>
          </div>
          @if (step.errorMessage) {
          <div class="step-error">{{ step.errorMessage }}</div>
          }
        </li>
        }
        }
      </ol>
    </div>
    }
  </div>

  <div class="row g-0 m-0 p-3 align-items-center bordert footer-row">
    @if (isInitializing || steps.length > 0) {
    <div class="col-md-12 mb-3">
      <div class="progress">
        <div class="progress-bar" role="progressbar" [style.width.%]="percentCompleted"
          [attr.aria-valuenow]="percentCompleted" aria-valuemin="0" aria-valuemax="100">
          {{ percentCompleted }}%
        </div>
      </div>
    </div>
    }

    <div class="col-md-4 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
      <span role="button" class="item-name">{{ "CLOSE_WINDOW" | translate }}</span>
    </div>

    <div class="col-md-3 p-2 d-flex justify-content-end edit rounded ms-auto cursor-pointer"
      [class.disabled]="isReconfigureDisabledFlag" (click)="!isReconfigureDisabledFlag && 
          (canRunPartialSetup 
            ? isSetupOptionModalOpen = true 
            : isSetupModalOpen = true)">
      <span class="item-name pe-2">{{ "RECONFIGUREDEVICE" | translate }}</span>
      <img alt="Edit" src="assets/device/unconfigured-meter.svg" />
    </div>
  </div>


  <app-confirm-dialog *ngIf="isSetupModalOpen" titleKey="SETUP"
    [question]="isForceFullSetup ? 'FORCE_FULL_SETUP_QUESTION' : 'DEVICES_SETUP'"
    (confirm)="confirmSetup()" (cancel)="cancelSetup()"></app-confirm-dialog>

  <app-setup-option-dialog *ngIf="isSetupOptionModalOpen"
    (optionSelected)="isSetupModalOpen = true; isSetupOptionModalOpen = false; isForceFullSetup = $event"
    (cancel)="isSetupOptionModalOpen = false"></app-setup-option-dialog>
</div>
